<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('user.koc.code')" prop="kocCode">
                <a-input v-model="queryParam.kocCode" :placeholder="$t('user.koc.inputCode')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('common.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('common.reset') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <!-- v-hasPermi="['user:koc:add']" -->
        <a-button type="primary" @click="$refs.createForm.handleAdd()">
          <a-icon type="plus" />{{ $t('common.add') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 'max-content' }"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="updateTime" slot-scope="text, record">
          {{ parseTime(record.updateTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
           <!-- v-hasPermi="['user:koc:edit']" -->
           <a-divider type="vertical" />
          <!-- v-hasPermi="['user:koc:edit']" -->
          <a @click="$refs.createForm.handleUpdate(record, undefined)" :disabled="record.useFlag==1">
              <a-icon type="edit" />{{ $t('common.edit') }}
            </a>
          <!-- v-hasPermi="['user:koc:remove']" -->
          <a-divider type="vertical" />
            <!-- v-hasPermi="['user:koc:remove']" -->
            <a @click="handleDelete(record)">
              <a-icon type="delete" />{{ $t('common.delete') }}
            </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => $t('table.total', { total })"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageKoc, delKoc } from '@/api/user/koc'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Koc',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        userId: null,
        kocCode: null,
        useFlag: null,
        type: null,
        numberValue: null,
        pageNum: 1,
        pageSize: 10
      },
    }
  },
  computed: {
    columns () {
      // 依赖 locale，切换语言时列标题与单元格文案会更新
      const _locale = this.$i18n.locale
      return [
        {
          title: this.$t('user.koc.code'),
          dataIndex: 'kocCode',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('user.koc.type'),
          dataIndex: 'type',
          ellipsis: true,
          align: 'center',
          customRender: (text) => this.formatKocType(text)
        },
        {
          title: this.$t('user.koc.numberValue'),
          dataIndex: 'numberValue',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('user.koc.useStatus'),
          dataIndex: 'useFlag',
          ellipsis: true,
          align: 'center',
          customRender: (text) => this.formatUseFlag(text)
        },
        {
          title: this.$t('user.koc.userNickname'),
          dataIndex: 'nickname',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('system.createTime'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('user.koc.useTime'),
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('common.operation'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.getList()
  },
  methods: {
    formatKocType (type) {
      const val = Number(type)
      if (val === 0) {
        return this.$t('user.koc.goldCard')
      }
      if (val === 1) {
        return this.$t('user.koc.vipCard')
      }
      return type
    },
    formatUseFlag (useFlag) {
      const val = Number(useFlag)
      if (val === 1) {
        return this.$t('user.koc.statusUsed')
      }
      if (val === 0) {
        return this.$t('user.koc.statusUnused')
      }
      return useFlag
    },
    /** 查询兑换码列表 */
    getList () {
      this.loading = true
      pageKoc(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = Number(response.data.total)
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        kocCode: undefined,
        useFlag: undefined,
        type: undefined,
        numberValue: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('system.confirmDelete'),
        content: this.$t('system.confirmDeleteContent') + ids,
        onOk() {
          return delKoc(ids)
            .then(() => {
              that.getList()
              that.$message.success(that.$t('system.deleteSuccess'), 3)
              that.ids = []
            })
            .catch(() => {
              that.ids = []
            })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('system.confirmExport'),
        content: this.$t('system.confirmExportContent'),
        onOk () {
          that.download('user/koc/export', {
            ...that.queryParam
          }, `${that.$t('user.koc.code')}_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>

<style scoped lang="less">
</style>
